
/* Common theme js */

$(document).ready(function() {

      // --- Preloader ---
    window.onload=new function() {
      $('.preloader').fadeOut(500, function(){ $('.preloader').remove(); } );
    };

      // --- Hover everything in a box ---
  $('a.box-title, a.box-title2, .more, .more2, .more4').hover(function(){
    $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').addClass('hover')
  }, function(){
    $(this).parents('.box').find('a.box-title, a.box-title2, .more, .more2, .more4').removeClass('hover')
  })


  // --- Menu ---
  function fixedMenu(){
    var myH = $('.header-topbar').not('.header-topbar-homepage').outerHeight()
    if($('.wp-block-cg-blocks-hero-bleed-card-image').length) {
      myH = $('.header-topbar').outerHeight()
    }

    if (myH) {
      if($('.sub-navigation').length <= 0){
        if ($(window).scrollTop() > 1){
          $('.header-topbar').addClass('fixed')
        } else {
          $('.header-topbar').removeClass('fixed')
        }
      }
      if($("#wpadminbar").length > 0){
        let height = $('.header-topbar').not('.header-topbar-homepage').outerHeight() + 25;
        // $('.header-topbar-wrapper').css('min-height', $('.header-topbar').not('.header-topbar-homepage').outerHeight());
      } else{
        let height = $('.header-topbar').not('.header-topbar-homepage').outerHeight() + 25;
        // $('.header-topbar-wrapper').css('min-height', height);
      }


    }
  }
  $(window).resize(function(){
    fixedMenu()
  })
  $(window).scroll(function() {
    fixedMenu()
  })
  fixedMenu()

   // --- Article ---

   if ($('.article').length) {
    var articleH
    function fixedArticleMenu(){
      var s = $('.article').position().top - $('.header-topbar').outerHeight()
      if ($(window).scrollTop() > s){
        $('.article-scroll').css('top', 0)
        $('.header-topbar, .sub-navigation').css('top', -150)
        $('.article-social').hide()
        var myScroll = $(window).scrollTop() - s
        $('.article-scrollbar').width(myScroll / articleH * 100 + '%')
      } else {
        $('.article-scroll, .header-topbar, .sub-navigation').attr('style', '')
        $('.article-social').show()
        $('.article-scrollbar').width(0)
      }
    }

    $(window).resize(function(){
      articleH = $('.article-body').outerHeight()
      fixedArticleMenu()
    })

    $(window).scroll(function() {
      fixedArticleMenu()
    })

    articleH = $('.article-body').outerHeight()
    fixedArticleMenu()

    $('.to-top').click(function(){
      $('html, body').animate({ scrollTop: 0 }, 500)
    })

    $(window).resize(lodash.debounce(fixedArticleMenu, 100))

  }

    // --- Resizer for fixed content-title on slider ---

    function partnerResize (){
        if ($('.section--event-slider').length > 0 && $(window).width() < 768) {
          var myTop = $('.section--event-slider .box-img-wrapper').height() + 24
          $('.section--event-slider .content-title').css('top', myTop)
        } else {
          $('.section--event-slider .content-title').attr('style', '')
        }
      }

      $(window).resize(lodash.debounce(

        function(){
          partnerResize()
        }, 100

    ))
    partnerResize()

    const hideLangTitles = () => {
        try {
          const langTitles = document.querySelectorAll('.lang-title');
          if(langTitles && langTitles.length > 0) {
            langTitles.forEach((langTitleNode) => {
              let subMenu = langTitleNode.nextElementSibling;
              const allLiElements = subMenu.querySelectorAll('li');
              if(allLiElements && allLiElements.length > 0) {
                const hiddenLiElements = Array.from(allLiElements).filter((liElement) => {
                  return window.getComputedStyle(liElement).getPropertyValue('display') == 'none';
                });
                if(allLiElements.length === hiddenLiElements.length) {
                  langTitleNode.style.display = 'none';
                }
              }
            })
          }
        } catch (e) {
          console.log(e);
        }
      }

       // lang search in menu for desktop
  //Fix bug 486503 happening because proper exception handling was not done.
  try {
    const searchInput = document.querySelector('#search-location-input');
    if(searchInput) {
      searchInput.addEventListener('input', function(e) {
        const menuLocations = document.querySelectorAll('.header_lang_menu .location-span')
        const searchedLocation = e.target.value
        menuLocations.forEach(item => item.innerHTML.toLowerCase().includes(searchedLocation.toLowerCase()) ? item.closest('li').style.display="block" : item.closest('li').style.display="none" );
        hideLangTitles();
      });
    }
  } catch (e) {
    //Error happened
    console.log(e);
  }
  // lang search in menu for mobile
  try {
    const searchInput = document.querySelector('#search-location-input_mobile');
    if(searchInput) {
      searchInput.addEventListener('input', function(e) {
        const menuLocations = document.querySelectorAll('.header_lang_menu_mobile .location-span')
        const searchedLocation = e.target.value
        menuLocations.forEach(item => item.innerHTML.toLowerCase().includes(searchedLocation.toLowerCase()) ? item.closest('li').style.display="block" : item.closest('li').style.display="none" )
        hideLangTitles();
      });
    }
  } catch (e) {
    //Error happened
    console.log(e);
  }

 /*Only for Analust page  & Event Agenda block Footer space*/
 if ($("#analystContactUsWrapper").length === 1 || $("#eventAgendaWrapper").length === 1) {
    $(".footer").css("margin-top", "0px");
  }

  $("a[target='_blank']").each(function() {
    let rel_attr = $(this).attr('rel');
    if( rel_attr === undefined || rel_attr === "" ) {
      $(this).attr("rel", "noopener noreferrer");
    }
  });


});